import {Component, Input} from '@angular/core';
import Article from '../../../smoothr-web-app-core/models/Article';
import {PreorderType} from '../../../smoothr-web-app-core/enums/PreorderType';
import {OrderType} from '../../../smoothr-web-app-core/enums/OrderType';
import ArticleGroup from '../../../smoothr-web-app-core/models/ArticleGroup';
import {environment} from 'src/environments/environment';
import {
	defaultsToArticleOption,
	getBasePrice,
	numberD,
	numberToCurrency
} from '../../../smoothr-web-app-core/utils/utils';
import {ValidationUtils} from 'src/smoothr-web-app-core/utils/validation-utils';
import OptionGroup from 'src/smoothr-web-app-core/models/OptionGroup';
import {ShortInfoModalComponent} from '../short-info-modal/short-info-modal.component';
import {ModalController} from '@ionic/angular';

@Component({
	selector: 'app-item-view',
	templateUrl: './item-view.component.html',
	styleUrls: ['item-view.component.scss']
})
export class ItemViewComponent {
	@Input() currency: string;
	price: number;
	ot = OrderType;
	environment = environment;
	@Input() hasOrder = false;
	@Input() isArticleSelected = false;
	priceText = '';
	numberToCurrency = numberToCurrency;

	constructor(private modalCtrl: ModalController) {}

	private _article: Article;

	get article(): Article {
		return this._article;
	}

	@Input()
	set article(value: Article) {
		this._article = value;
		this.reloadPrice();
	}

	private _preorderType: PreorderType = null;

	get preorderType(): PreorderType {
		return this._preorderType;
	}

	@Input()
	set preorderType(value: PreorderType) {
		this._preorderType = value;
		this.reloadPrice();
	}

	private minOfItem<T>(items: T[], transformer: (item: T) => number): T {
		if (items.length === 1) {
			return items[0];
		}
		const values = items.map(item => transformer(item));
		const min = Math.min(...values);
		const index = values.indexOf(min);
		return items[index];
	}

	private hasDefault(article: Article, group: OptionGroup) {
		return article.defaults.some(mArt => group.articles.some(gArt => gArt._id === mArt.article));
	}

	private reloadPrice() {
		const articleGroup = new ArticleGroup();
		articleGroup.article = this.article;
		articleGroup.groups = defaultsToArticleOption(this.article, [], [], this.preorderType);

		articleGroup.quantity = 1;

		const article = articleGroup.article;
		let price = numberD(article.price);
		const processedGroups: string[] = [];
		article.groups.forEach(grp => {
			if (processedGroups.indexOf(grp._id) >= 0) return;
			if (ValidationUtils.isGroupDependencyFulfilled(articleGroup.article, articleGroup.groups, grp).times < 0) return;

			if (grp.requiredAmount == grp.limit && this.hasDefault(this.article, grp)) {
				const minimumItem = this.minOfItem(grp.articles, opt => numberD(opt.price));

				price += numberD(minimumItem.price) * grp.requiredAmount;

				const dependants = this.dependenciesRegardingOptionArticle(article, article.groups, minimumItem);

				dependants.forEach(dependant => {
					const dependantMinimumItem = this.minOfItem(dependant.articles, opt => numberD(opt.price));
					price += grp.requiredAmount * dependant.requiredAmount * numberD(dependantMinimumItem.price);
					processedGroups.push(dependant._id);
				});

				processedGroups.push(grp._id);
			}
		});

		const tagPrice = this.findTagPrice(this.article);
		if (tagPrice && tagPrice > 0) {
			price = price - tagPrice;
		}
		this.price = price;
		this.priceText = numberToCurrency(this.price, this.currency);
		return;
	}
	dependenciesRegardingOptionArticle(article: Article, groups: OptionGroup[], optionArticle: Article): OptionGroup[] {
		return article.groupDependencies
			.map(gd => {
				if (gd.dependencies.find(dependeci => dependeci.groupArticles.includes(optionArticle._id)) == null) {
					return null;
				} else {
					return groups.find(it => gd.group === it._id);
				}
			})
			.filter(it => !!it);
	}
	isFromPrice(article: Article) {
		// if (article._id === '66068f2303ce98995bd3527a') {
		// 	console.log(article);
		// }

		return !!article.tags.find(tag => tag.identifier === 'fromPrice');
	}

	getArticlePrice(article: Article, price: number) {
		let totalPrice = price;
		console.log(article.name.de, totalPrice);

		const tagPrice = this.findTagPrice(this.article);
		if (tagPrice && tagPrice > 0) {
			totalPrice = totalPrice - tagPrice;
		}
		return totalPrice;
	}
	findTagPrice(article: Article) {
		if (article && article.tags && article.tags.length > 0) {
			const foundTag = article?.tags?.find(
				it => it?.identifier === 'deposit_25' || it?.identifier === 'deposit_15' || it?.identifier === 'deposit_8'
			);
			if (foundTag) {
				return foundTag.identifier === 'deposit_25'
					? 0.25
					: foundTag.identifier === 'deposit_15'
					  ? 0.15
					  : foundTag.identifier === 'deposit_8'
					    ? 0.8
					    : 0;
			}
		} else {
			return null;
		}
	}

	checkPfandTag(article: Article) {
		if (article.tags?.length === 0) {
			return '';
		}
		const deposit25 = article.tags.find(it => it.identifier === 'deposit_25') ? 'deposit25' : '';
		const deposit15 = article.tags.find(it => it.identifier === 'deposit_15') ? 'deposit15' : '';
		const deposit8 = article.tags.find(it => it.identifier === 'deposit_8') ? 'deposit8' : '';

		return deposit15 || deposit25 || deposit8;
	}

	showMeasurement(article: Article) {
		if (article) {
			if (article?.measurement?.refAmount && article?.measurement?.refUnit) {
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'g') {
					return (
						'1' +
						' ' +
						'kg' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType) * 10, this.currency)
					);
				}
				if (article?.measurement?.refAmount == 100 && article?.measurement?.refUnit === 'ml') {
					return (
						'1' +
						' ' +
						'l' +
						' = ' +
						numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType) * 10, this.currency)
					);
				}
				return (
					article.measurement.refAmount +
					' ' +
					article.measurement.refUnit +
					' = ' +
					numberToCurrency(getBasePrice(article, OrderType.PREORDER, this.preorderType), this.currency)
				);
			}
		} else {
			return '';
		}
	}

	getArticleTags() {
		return Object.entries(this.article?.compound?.features || {})
			.filter(value => value[1] === true)
			.map(it => it[0]);
	}

	openInfo(event: Event, article: Article) {
		event.stopPropagation();
		ShortInfoModalComponent.show(this.modalCtrl, article);
	}

	stockAmountQuantity(article: Article) {
		return article.stockAmount <= 0 ? 0 : article.stockAmount;
	}

	hasAvailablePortionTag(article: Article) {
		return article.tags.some(tag => tag.identifier === 'available_portions_shown');
	}

	isNeededToShowStock(article: Article) {
		return this.hasAvailablePortionTag(article) && this.stockAmountQuantity(article) <= 0;
	}
}
